namespace GeniuzPOS.InitialData {
    export interface PsCreditCardForm {
        CreditCardType: Serenity.StringEditor;
        CreditCardName: Serenity.StringEditor;
        ProdImageLink: Serenity.ImageUploadEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class PsCreditCardForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsCreditCard';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsCreditCardForm.init)  {
                PsCreditCardForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ImageUploadEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(PsCreditCardForm, [
                    'CreditCardType', w0,
                    'CreditCardName', w0,
                    'ProdImageLink', w1,
                    'IsActive', w2
                ]);
            }
        }
    }
}
